import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { BloccoModel } from "../../../models/dashboard/blocco.model";
import {
  MdDialog,
  MdDialogConfig,
  MdDialogActions,
  MdDialogContainer,
  MdDialogContent,
} from "@angular/material";
import { ItemManagerComponent } from "../../utils/item-manager/item-manager.component";
import { DashboardService } from "../../../services/dashboard.service";

@Component({
  selector: "app-manager-grid-item",
  templateUrl: "./manager-grid-item.component.html",
  styleUrls: ["./manager-grid-item.component.css"],
})
export class ManagerGridItemComponent implements OnInit {
  @Input() blocco: BloccoModel;

  roles: string;

  constructor() {}

  ngOnInit() {
    this.roles = this.blocco.authManItems.map((item) => item.name).join(" - ");
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/homepage-manager/manager-grid-item/manager-grid-item.component.ts